import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'custom-icon-button',
  templateUrl: './custom-icon-button.component.html',
  styleUrls: ['./custom-icon-button.component.css']
})
export class CustomIconButtonComponent implements OnInit {
  @Input() type!: string;

  icon!: string;

  colorClass!: string;

  tooltip!: string;

  ngOnInit(): void {
    if(this.type == 'warning') {
      this.icon = 'pi pi-pencil';
      this.colorClass = 'p-button-warning';
      this.tooltip = 'Editar'
    }
    else {
      this.icon = 'pi pi-trash';
      this.colorClass = 'p-button-danger';
      this.tooltip = 'Eliminar'
    }
  }
}